<div>
    <div class="row">
        <div class="col-12">
            <span class="serviceDataTitle muted-color"> {{ 'SERVICE_DATA.LABEL1' | translate }} </span>
        </div>
    </div>
    <div class="row mb-2">
        <div class="col-12">
            <span class="serviceDataSubtitle muted-color"> {{ 'SERVICE_DATA.LABEL2' | translate }} </span>
        </div>
    </div>
    <div class="row">
        <form [formGroup]="formGroup">
            <div class="col-12">
                <mat-card>
                    <mat-card-content>
                        <div class="row">
                            <div class="col-12">
                                <span class="serviceDataText muted-color"> {{ 'SERVICE_DATA.LABEL3' | translate }} </span>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2">
                                <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                                    <mat-label> {{ 'SERVICE_DATA.LABEL4' | translate }} </mat-label>
                                    <mat-select formControlName="day">
                                      <mat-option [value]="day" *ngFor = "let day of days">{{day}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2">
                                <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                                    <mat-label> {{ 'SERVICE_DATA.LABEL5' | translate }} </mat-label>
                                    <mat-select formControlName="month">
                                      <mat-option [value]="month" *ngFor = "let month of months">{{month}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2">
                                <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                                    <mat-label> {{ 'SERVICE_DATA.LABEL6' | translate }} </mat-label>
                                    <mat-select formControlName="year">
                                      <mat-option [value]="year" *ngFor = "let year of years">{{year}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-md-6"></div>
                            <div class="col-12">
                                <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                                    <mat-label> {{ 'SERVICE_DATA.LABEL7' | translate }} </mat-label>
                                    <textarea maxlength="125" (keypress)="commonService.validateSpecialCharDescription($event)" onpaste="return false" matInput placeholder="" formControlName="description"></textarea>
                                </mat-form-field>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                <div class="d-none d-sm-none d-md-flex justify-content-end my-5">
                    <button class="w-25 p-1" type="button" (click)="stepBack()" mat-raised-button
                        color="accent"> {{ 'SERVICE_DATA.LABEL8' | translate }} </button>
                    <button class="w-25 p-1 mx-2" type="submit" (click)="stepOn()" mat-raised-button
                        color="primary"> {{ 'SERVICE_DATA.LABEL9' | translate }} </button>
                </div>
                <div class="d-block d-sm-block d-md-none">
                    <mat-card class="serviceCard my-3">
                        <mat-card-content>
                            <button class="w-100 p-1 mx-2" type="submit" (click)="stepOn()" mat-raised-button
                                color="primary"> {{ 'SERVICE_DATA.LABEL9' | translate }} </button>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </form>
    </div>
</div>